import { cn } from "@/lib/utils";

export function RadialStarBurst({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "absolute inset-0 scale-170 w-full h-full pointer-events-none",
        className,
      )}
    >
      <svg
        className="absolute inset-0 w-full h-full animate-[spin_30s_linear_infinite]"
        viewBox="0 0 348 430"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g style={{ mixBlendMode: "color-dodge" }} opacity="0.5">
          <path
            d="M208.991 205.149L398.749 119.302L386.222 97.6046L381.267 89.0204L368.739 67.3234L199.516 188.734L320.927 19.511L299.23 6.98326L290.645 2.02834L268.948 -10.4994L183.101 179.259L203.633 -28H178.58H168.67H143.617L164.149 179.259L78.3016 -10.4994L56.6046 2.02834L48.0204 6.98326L26.3234 19.511L147.734 188.734L-21.489 67.3234L-34.0167 89.0204L-38.9717 97.6046L-51.4994 119.302L138.259 205.149L-69 184.617V209.67V219.58V244.633L138.259 224.101L-51.4994 309.948L-38.9717 331.645L-34.0167 340.23L-21.489 361.927L147.734 240.516L26.3234 409.739L48.0204 422.267L56.6046 427.222L78.3016 439.749L164.149 249.991L143.617 457.25H168.67H178.58H203.633L183.101 249.991L268.948 439.749L290.645 427.222L299.23 422.267L320.927 409.739L199.516 240.516L368.739 361.927L381.267 340.23L386.222 331.645L398.749 309.948L208.991 224.101L416.25 244.633V219.58V209.67V184.617L208.991 205.149Z"
            fill="url(#paint0_radial_star_burst)"
            style={{ mixBlendMode: "overlay" }}
          />
        </g>
        <defs>
          <radialGradient
            id="paint0_radial_star_burst"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(173.625 214.625) scale(242.625)"
          >
            <stop stopColor="#FFDF20" stopOpacity="0.75" />
            <stop offset="0.723097" stopColor="white" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
}
